<template>
  <div class="table-wrapper">
    <div class="table-container">
      <v-data-table v-model="selectedItems" :headers="visibleHeaders" :items="projects" item-value="id"
        hide-default-header :items-per-page="store?.items_per_page" :hide-default-footer="true"
        class="data-table-no-border">
        <template v-slot:thead>
          <thead>
            <tr>
              <!-- <th v-if="!removeSelect">
                <v-checkbox
                  v-model="isAllSelected"
                  @change="toggleSelectAll"
                  :indeterminate="isIndeterminate"
                  hide-details
                ></v-checkbox>
              </th> -->
              <th v-for="header in visibleHeaders" :key="header.key">
                <div v-if="header.menu" class="d-flex justify-space-between align-center">
                  <span>{{ header.title }} </span>
                  <div class="options">
                    <div class="menu align-center">
                      <svg @click="hideColumn(header.key)" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3348_28197)">
                          <path
                            d="M0.666748 8.00008C0.666748 8.00008 3.33341 2.66675 8.00008 2.66675C12.6667 2.66675 15.3334 8.00008 15.3334 8.00008C15.3334 8.00008 12.6667 13.3334 8.00008 13.3334C3.33341 13.3334 0.666748 8.00008 0.666748 8.00008Z"
                            stroke="#666666" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M8.00008 10.0001C9.10465 10.0001 10.0001 9.10465 10.0001 8.00008C10.0001 6.89551 9.10465 6.00008 8.00008 6.00008C6.89551 6.00008 6.00008 6.89551 6.00008 8.00008C6.00008 9.10465 6.89551 10.0001 8.00008 10.0001Z"
                            stroke="#666666" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                          <clipPath id="clip0_3348_28197">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-else>
                  {{ header.title }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item.project="{ item }">
          <div class="d-flex align-center ga-2">
            <span class="cursor-pointer" @click="
              $router.push({ name: 'ShowProject', params: { id: item.id } })
              ">
              {{ item.project_number }}
            </span>
          </div>
        </template>
        <template v-slot:item.members="{ item }">
          <div class="d-flex align-center ga-2">
            <span v-for="(member, index) in item.members" :key="index">
              <img class="circle-img" :src="member.image" :alt="member.name" />
            </span>
          </div>
        </template>
        <template v-slot:item.description="{ item }">
          <div class="d-flex align-center ga-2">
            <span>{{
              item.description?.length > 20
                ? item.description.slice(0, 20) + "..."
                : item.description
            }}</span>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <Status :item="item" :id="item.id" :disabled="!$permissionsFor('leads-managment').update"
            :class="{ 'read-only': !$permissionsFor('leads-managment').update }" />
        </template>
        <template v-slot:item.contacts="{ item }">
          <div class="d-flex align-center ga-2">
            <div v-if="item.contacts.length > 0" class="d-flex align-center ga-2">
              <span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.02 7.60612C13.6886 7.04784 14.1284 6.23845 14.2481 5.34598C14.3678 4.45352 14.1581 3.54655 13.6627 2.81338C13.1673 2.08022 12.4241 1.57719 11.5875 1.40874C10.7509 1.24029 9.88516 1.41935 9.17001 1.90876C8.87035 1.40178 8.46868 0.971034 7.99367 0.647254C7.51866 0.323474 6.982 0.114633 6.42197 0.0356268C5.86194 -0.0433795 5.29234 0.00939544 4.75379 0.190187C4.21525 0.370979 3.72103 0.675334 3.30638 1.08154C2.89173 1.48775 2.56688 1.98581 2.35498 2.54019C2.14308 3.09456 2.04937 3.69161 2.08052 4.28873C2.11167 4.88585 2.26691 5.46834 2.53519 5.99466C2.80346 6.52097 3.17815 6.97814 3.63253 7.33355C2.55463 7.80358 1.63344 8.60283 0.986477 9.62935C0.339511 10.6559 -0.00390618 11.8631 3.35208e-05 13.0971C3.35208e-05 13.5919 0.192533 14.3091 1.11003 14.9124C2.20753 15.6375 4.05752 16 5.90752 16C7.68252 16 9.45751 15.6639 10.5675 14.9944H10.91C12.52 14.9944 14.5125 14.6663 15.4475 13.7163C15.6155 13.5609 15.7512 13.3705 15.8463 13.1569C15.9414 12.9433 15.9937 12.7112 16 12.4752C15.9991 11.446 15.7174 10.439 15.1887 9.57523C14.6601 8.71145 13.907 8.02768 13.02 7.60612ZM10.9425 2.438C11.3369 2.43812 11.7247 2.54489 12.0692 2.74818C12.4137 2.95147 12.7034 3.24454 12.9108 3.5996C13.1182 3.95466 13.2365 4.35993 13.2545 4.77696C13.2724 5.194 13.1894 5.60897 13.0133 5.98251C12.8372 6.35606 12.5739 6.67579 12.2483 6.91137C11.9227 7.14696 11.5456 7.29059 11.1529 7.32865C10.7601 7.3667 10.3647 7.29791 10.0041 7.1288C9.64354 6.9597 9.32975 6.69588 9.09251 6.36238C9.41478 5.86159 9.62696 5.29075 9.71349 4.69178C9.80001 4.09281 9.75867 3.48094 9.59251 2.9011C9.98522 2.60013 10.4577 2.43807 10.9425 2.438ZM8.78751 7.64316C8.59424 7.52941 8.39565 7.42607 8.19252 7.33355C8.26752 7.27534 8.34251 7.21447 8.41502 7.14832C8.55034 7.31538 8.70016 7.46865 8.86251 7.60612L8.78751 7.64316ZM3.06753 4.0628C3.06753 3.46719 3.23438 2.88497 3.54699 2.38974C3.85961 1.89451 4.30393 1.50853 4.82379 1.2806C5.34364 1.05268 5.91568 0.993041 6.46755 1.10924C7.01943 1.22543 7.52636 1.51224 7.92423 1.9334C8.32211 2.35455 8.59307 2.89114 8.70285 3.4753C8.81262 4.05946 8.75628 4.66495 8.54095 5.21522C8.32562 5.76549 7.96097 6.23581 7.49311 6.56671C7.02526 6.8976 6.47521 7.07422 5.91252 7.07422C5.15818 7.07352 4.43493 6.75602 3.90154 6.19142C3.36814 5.62682 3.06819 4.86126 3.06753 4.0628ZM1.64503 14.0127C1.22253 13.7348 1.00003 13.4279 1.00003 13.0971C0.996737 11.8911 1.39094 10.7218 2.11471 9.79046C2.83848 8.85914 3.84649 8.22423 4.96502 7.99512C5.58613 8.16803 6.23891 8.16803 6.86002 7.99512C7.97785 8.22484 8.98497 8.86009 9.70783 9.79141C10.4307 10.7227 10.824 11.8918 10.82 13.0971C10.82 13.4252 10.6075 13.7295 10.1875 14.0074H10.1725C8.29501 15.2511 3.52003 15.2485 1.64503 14.0127ZM14.7625 12.9542C14.2625 13.4834 13.0425 13.8301 11.6275 13.9174C11.7537 13.6627 11.8198 13.3794 11.82 13.0918C11.8223 12.1946 11.6409 11.3075 11.2883 10.4917C10.9357 9.67579 10.4203 8.95046 9.77751 8.36559C9.89751 8.32854 10.0275 8.29679 10.135 8.27297C10.3991 8.3428 10.6703 8.37834 10.9425 8.37882C11.2124 8.37796 11.4811 8.34151 11.7425 8.27032C12.6615 8.46341 13.4887 8.98821 14.0829 9.75511C14.677 10.522 15.0011 11.4834 15 12.4752C14.9949 12.5691 14.9711 12.6608 14.9302 12.7442C14.8893 12.8277 14.8321 12.901 14.7625 12.9595V12.9542Z"
                    fill="#666666" />
                </svg>
              </span>
              <span>{{ item.contacts[0].name }}</span>
              <span style="width: 15px" v-if="item.contacts.length > 1">
                <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="18" stroke="#237276" stroke-width="2" fill="none" />
                  <text x="20" y="23" font-size="12" fill="#237276" text-anchor="middle" alignment-baseline="middle"
                    font-family="Arial, sans-serif" font-weight="bold">
                    +{{ item.contacts.length - 1 }}
                  </text>
                </svg>
              </span>
            </div>
            <div v-else>No Contact</div>
          </div>
        </template>
        <template v-slot:item.account="{ item }">
          <div class="d-flex align-center ga-2">
            <div class="d-flex align-center ga-2">
              <span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_3541_59805)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.25533 2.18182V15.2727H1.16442C0.963589 15.2727 0.800781 15.4356 0.800781 15.6364C0.800781 15.8372 0.963589 16 1.16442 16H16.4371C16.6379 16 16.8008 15.8372 16.8008 15.6364C16.8008 15.4356 16.6379 15.2727 16.4371 15.2727H15.3462V2.18182C15.3462 0.976836 14.3694 0 13.1644 0H4.43714C3.23216 0 2.25533 0.976836 2.25533 2.18182ZM14.619 15.2727V2.18182C14.619 1.37849 13.9678 0.727273 13.1644 0.727273H4.43714C3.63382 0.727273 2.9826 1.37849 2.9826 2.18182V15.2727H5.89169V11.6364C5.89169 10.4313 6.86853 9.45455 8.07351 9.45455H9.52805C10.7331 9.45455 11.7099 10.4313 11.7099 11.6364V15.2727H14.619ZM10.9826 15.2727V11.6364C10.9826 10.833 10.3314 10.1818 9.52805 10.1818H8.07351C7.27018 10.1818 6.61896 10.833 6.61896 11.6364V15.2727H10.9826ZM5.16442 4C5.16442 3.79917 5.32722 3.63636 5.52805 3.63636H7.70987C7.91067 3.63636 8.07351 3.79917 8.07351 4C8.07351 4.20083 7.91067 4.36364 7.70987 4.36364H5.52805C5.32722 4.36364 5.16442 4.20083 5.16442 4ZM5.52805 6.54545C5.32722 6.54545 5.16442 6.70829 5.16442 6.90909C5.16442 7.10989 5.32722 7.27273 5.52805 7.27273H7.70987C7.91067 7.27273 8.07351 7.10989 8.07351 6.90909C8.07351 6.70829 7.91067 6.54545 7.70987 6.54545H5.52805ZM9.52805 4C9.52805 3.79917 9.69089 3.63636 9.89169 3.63636H12.0735C12.2743 3.63636 12.4371 3.79917 12.4371 4C12.4371 4.20083 12.2743 4.36364 12.0735 4.36364H9.89169C9.69089 4.36364 9.52805 4.20083 9.52805 4ZM9.89169 6.54545C9.69089 6.54545 9.52805 6.70829 9.52805 6.90909C9.52805 7.10989 9.69089 7.27273 9.89169 7.27273H12.0735C12.2743 7.27273 12.4371 7.10989 12.4371 6.90909C12.4371 6.70829 12.2743 6.54545 12.0735 6.54545H9.89169Z"
                      fill="#666666" />
                  </g>
                  <defs>
                    <clipPath id="clip0_3541_59805">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>{{ item.account?.name }}</span>
            </div>
          </div>
        </template>
        <template v-slot:item.due_date="{ item }">
          <div class="d-flex align-center ga-2">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.6667 1.33337V4.00004M5.33333 1.33337V4.00004M2 6.66671H14M3.33333 2.66671H12.6667C13.403 2.66671 14 3.26366 14 4.00004V13.3334C14 14.0698 13.403 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0698 2 13.3334V4.00004C2 3.26366 2.59695 2.66671 3.33333 2.66671Z"
                stroke="#237276" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>{{ formatDate(item.due_date) }}</span>
          </div>
        </template>
        <template v-slot:item.added_date="{ item }">
          <div class="d-flex align-center ga-2">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.6667 1.33337V4.00004M5.33333 1.33337V4.00004M2 6.66671H14M3.33333 2.66671H12.6667C13.403 2.66671 14 3.26366 14 4.00004V13.3334C14 14.0698 13.403 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0698 2 13.3334V4.00004C2 3.26366 2.59695 2.66671 3.33333 2.66671Z"
                stroke="#237276" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>{{ formatDate(item.added_date) }}</span>
          </div>
        </template>
        <template v-slot:item.add_to_calendar="{ item }">
          <AddToCalendar :item="item" :id="item.id" :disabled="!$permissionsFor('leads-managment').update"
            :class="{ 'read-only': !$permissionsFor('leads-managment').update }" />
        </template>
        <template v-slot:item.probability="{ item }">
          {{ item.probability }}%
        </template>
        <template v-slot:item.challenges="{ item }">
          <span>{{
            item.challenges.length > 20
              ? item.challenges.slice(0, 20) + "..."
              : item.challenges
          }}</span>
        </template>
        <template v-slot:item.feedback="{ item }">
          <span>{{
            item.feedback && item.feedback.length > 20
              ? item.feedback.slice(0, 20) + "..."
              : item.feedback
          }}</span>
        </template>
        <template v-slot:item.comment="{ item }">
          <span v-if="item?.notes?.length > 0">{{
            item.notes && item.notes.length > 20
              ? item.notes.slice(0, 20) + "..."
              : item.notes
          }}</span>
          <span v-else> no comment </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <Actions :item="item" />
        </template>
      </v-data-table>
    </div>
  </div>
  <Pagination v-if="store?.total_projects > 5" :store="store" />
</template>

<script>
import { format } from "date-fns";
import { useProjectsStore } from "@/store/crm/useProjectsStore";
import Status from "@/components/crm/projects/table/Status.vue";
import Actions from "@/components/crm/projects/table/Actions.vue";
import Pagination from "@/components/crm/assets/Pagination.vue";
import AddToCalendar from "@/components/crm/projects/table/AddToCalendar.vue";

export default {
  name: "CustomDataTable",
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
    removeSelect: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Actions,
    Status,
    Pagination,
    AddToCalendar,
  },

  data() {
    return {
      selectedItems: [],
      store: null,
      add_to_calendar: true,
    };
  },
  watch: {
    selectedItems() {
      this.$emit("update:selected_projects", this.selectedItems);
    },
    add_to_calendar() { },
  },
  computed: {
    visibleHeaders() {
      return this.store?.getHeaders.filter((header) => header.show) || [];
    },
    isAllSelected() {
      return (
        this.selectedItems.length === this.projects.length &&
        this.projects.length > 0
      );
    },
    isIndeterminate() {
      return (
        this.selectedItems.length > 0 &&
        this.selectedItems.length < this.projects.length
      );
    },
  },

  methods: {
    formatDate(date) {
      return format(new Date(date), "MMM dd, yyyy HH:mm");
    },
    renameColumn(key) {
      const header = this.store.headers.find((h) => h.key === key);
      if (header) {
        header.title = "new title";
      }
    },
    hideColumn(key) {
      const header = this.store.headers.find((h) => h.key === key);
      if (header) {
        header.show = false;
      }
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.projects.map((item) => item.id);
      }
    },
  },

  created() {
    this.store = useProjectsStore();
  },
  mounted() {
    this.store.getAllProjects();
    this.store.headers.map((e) => {
      e.show = true
    })
  },
};
</script>

<style>
.table-container .v-table {
  margin: 0px !important;
}

.table-container .v-table .v-data-table-footer {
  justify-content: space-between !important;
}

.table-container .v-table .v-table__wrapper table thead {
  background: #edf1f1;
  color: #535862;
}

.table-container .v-table .v-table__wrapper table tbody tr:hover {
  background: #adadad27;
}

.table-container .v-table .v-table__wrapper table tbody tr td {
  padding: 16px 24px;
  white-space: nowrap;
}

.table-container thead tr th:hover {
  background-color: #adadad27 !important;
}

.table-container thead tr th div .options .menu {
  transition: all 0.5s ease-in-out;
  cursor: pointer;
}

.table-container thead tr th div .options .menu {
  display: none;
}

.table-container thead tr th:hover>div .options .menu {
  display: flex;
}

.data-table-no-border .v-table__wrapper>table>tbody>tr:not(:last-child)>td,
.data-table-no-border .v-table__wrapper>table>tbody>tr:not(:last-child)>th {
  border: none !important;
}

.data-table-no-border>.v-table__wrapper>table>tbody>tr>th,
.data-table-no-border>.v-table__wrapper>table>thead>tr>th,
.data-table-no-border>.v-table__wrapper>table>tfoot>tr>th {
  border: none !important;
}
</style>

<style scoped>
.table-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.table-container {
  width: 100%;
  position: relative;
  overflow-x: auto;
}

.v-data-table {
  width: 100%;
  margin: 1rem 0;
}

:deep(.v-data-table__wrapper) {
  overflow-x: auto;
  width: 100%;
}

:deep(.v-data-table > .v-data-table__wrapper > table) {
  width: 100%;
  white-space: nowrap;
}

:deep(.v-data-table th) {
  white-space: nowrap;
  min-width: 120px;
  padding: 16px 24px;
  font-weight: 600;
  text-transform: capitalize;
}

.phone-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666666;
  text-decoration: none;
}

.phone-link:hover {
  text-decoration: underline;
}

:deep(.v-data-table) {
  text-transform: capitalize;
}

:deep(.v-data-table__checkbox) {
  width: 48px;
  padding-left: 16px !important;
}

.menu-options-list .v-list-item .v-list-item__content .v-list-item-title {
  width: 150px;
  height: 36px;
  padding: 12px 16px 12px 16px;
  border-radius: 4px;
  margin: 6px 0px;
}

.menu-options-list .v-list-item .v-list-item__content .v-list-item-title:hover {
  background: #c0c0c0;
  color: white;
}
</style>
